//# sourceMappingURL=translations.mjs.map
/// <reference types="./translations.d.mts" />
import * as $html_parser from "../../../../data_types/common/html_parser.mjs";
import * as $proposal from "../../../../data_types/data/proposal.mjs";
import * as $proposal_element from "../../../../data_types/data/proposal_element.mjs";
import * as $answer from "../../../../data_types/data/proposal_element/answer.mjs";
import * as $question from "../../../../data_types/data/proposal_element/question.mjs";
import * as $remote from "../../../../data_types/data/remote.mjs";
import * as $translate from "../../../../data_types/data/translate.mjs";
import * as $language from "../../../../data_types/data/translate/language.mjs";
import * as $iso639 from "../../../../data_types/data/translate/language/iso639.mjs";
import * as $button from "../../../../ds/ds/components/button.mjs";
import * as $l from "../../../../ds/ds/components/layout.mjs";
import * as $modal from "../../../../ds/ds/components/modal.mjs";
import * as $skeleton from "../../../../ds/ds/components/skeleton.mjs";
import * as $table from "../../../../ds/ds/components/table.mjs";
import * as $icons from "../../../../ds/ds/icons.mjs";
import * as $utils from "../../../../ds/ds/utils.mjs";
import * as $promise from "../../../../gleam_javascript/gleam/javascript/promise.mjs";
import * as $dict from "../../../../gleam_stdlib/gleam/dict.mjs";
import * as $int from "../../../../gleam_stdlib/gleam/int.mjs";
import * as $list from "../../../../gleam_stdlib/gleam/list.mjs";
import * as $option from "../../../../gleam_stdlib/gleam/option.mjs";
import * as $result from "../../../../gleam_stdlib/gleam/result.mjs";
import * as $string from "../../../../gleam_stdlib/gleam/string.mjs";
import * as $redraw from "../../../../redraw/redraw.mjs";
import * as $a from "../../../../redraw_dom/redraw/dom/attribute.mjs";
import * as $e from "../../../../redraw_dom/redraw/dom/events.mjs";
import * as $h from "../../../../redraw_dom/redraw/dom/html.mjs";
import * as $effect from "../../../../redraw_lustre/redraw/lustre/effect.mjs";
import * as $css from "../../../../sketch/sketch/css.mjs";
import * as $length from "../../../../sketch/sketch/css/length.mjs";
import { px } from "../../../../sketch/sketch/css/length.mjs";
import * as $html from "../../../../sketch_redraw/sketch/redraw/dom/html.mjs";
import * as $timestamp_ from "../../../../tiamat/gleam/time/timestamp_.mjs";
import * as $function from "../../../../tiamat/tiamat/function.mjs";
import * as $answer_effects from "../../../admin/effects/answer.mjs";
import * as $proposal_effects from "../../../admin/effects/proposal.mjs";
import * as $store from "../../../data/store.mjs";
import { Ok, Error, toList, Empty as $Empty, prepend as listPrepend, isEqual } from "../../../gleam.mjs";
import * as $versioning_common from "../../../view/project/versioning/common.mjs";

function confirm_retranslate() {
  return $redraw.component_(
    "ConfirmRetranslate",
    (props) => {
      let on_cancel = $e.on_click(
        (_) => { return props.on_end(new Error(undefined)); },
      );
      let on_confirm = $e.on_click(
        (_) => { return props.on_end(new Ok(undefined)); },
      );
      return $modal.modal(
        toList([]),
        toList([
          $modal.body(
            toList([$utils.stop_propagation()]),
            toList([
              $modal.title(
                toList([]),
                toList([$h.text("Retranslate all answers?")]),
              ),
              $modal.explanations(
                toList([]),
                toList([
                  $h.text(
                    "This will relaunch translation for all AnswerV2 in this proposal. ",
                  ),
                  $h.text(
                    "Existing translations will be overwritten. This action cannot be undone.",
                  ),
                ]),
              ),
              $modal.actions(
                toList([]),
                toList([
                  $button.secondary(
                    toList([on_cancel]),
                    toList([$h.text("Cancel")]),
                  ),
                  $button.primary(
                    toList([on_confirm]),
                    toList([$h.text("Confirm")]),
                  ),
                ]),
              ),
            ]),
          ),
        ]),
      );
    },
  );
}

function use_retranslate_click(confirm, proposal_id, org_id) {
  let modal_ctx = $modal.use_modal();
  let effect_dispatch = $store.use_effect_dispatch();
  return ((_capture) => {
    return $redraw.use_callback(_capture, [confirm, proposal_id, org_id]);
  })(
    (_) => {
      return $function.tap(
        undefined,
        (_) => {
          let return$ = modal_ctx.open(confirm);
          return $promise.map(
            return$,
            (return$) => {
              return $result.map(
                return$,
                (_) => {
                  return effect_dispatch(
                    $proposal_effects.retranslate_answers(proposal_id, org_id),
                  );
                },
              );
            },
          );
        },
      );
    },
  );
}

/**
 * Every language the proposal is configured for, default language included.
 * Mirrors the language set heimdall translates toward, so a language with no
 * translation row yet still gets a column (and therefore a trigger).
 * 
 * @ignore
 */
function proposal_languages(proposal) {
  let _pipe = proposal.metadata.default_language;
  let _pipe$1 = $option.map(
    _pipe,
    (_capture) => {
      return $list.prepend(proposal.metadata.languages, _capture);
    },
  );
  let _pipe$2 = $option.map(_pipe$1, $list.unique);
  return $option.unwrap(_pipe$2, proposal.metadata.languages);
}

function language_label(lang) {
  return $string.uppercase($iso639.to_string(lang));
}

function title_header() {
  return $redraw.compose(
    confirm_retranslate(),
    (confirm) => {
      return $redraw.component_(
        "TranslationsHeader",
        (proposal) => {
          let state = $store.use_state();
          let effect_dispatch = $store.use_effect_dispatch();
          let org_id = $option.unwrap(state.organization, "");
          let on_retranslate = use_retranslate_click(
            confirm,
            proposal.id,
            org_id,
          );
          let fill_missing_buttons = $list.map(
            proposal_languages(proposal),
            (lang) => {
              return $button.secondary(
                toList([
                  $e.on_click(
                    (_) => {
                      let _block;
                      let _pipe = $proposal_effects.translate_missing(
                        proposal.id,
                        org_id,
                        lang,
                      );
                      _block = effect_dispatch(_pipe);
                      let $ = _block;
                      
                      return undefined;
                    },
                  ),
                ]),
                toList([$h.text("Fill missing " + language_label(lang))]),
              );
            },
          );
          return $versioning_common.proposal_title(
            proposal.name + " — Translations",
            $l.row(
              toList([$l.gap(8)]),
              toList([]),
              $list.flatten(
                toList([
                  fill_missing_buttons,
                  toList([
                    $button.secondary(
                      toList([$e.on_click(on_retranslate)]),
                      toList([$h.text("Retranslate answers")]),
                    ),
                    $html.a(
                      $css.class$(
                        toList([
                          $css.text_decoration("none"),
                          $css.color("black"),
                        ]),
                      ),
                      toList([$a.href("/proposal/versioning/" + proposal.id)]),
                      toList([
                        $button.secondary(
                          toList([]),
                          toList([$h.text("Original")]),
                        ),
                      ]),
                    ),
                  ]),
                ]),
              ),
            ),
          );
        },
      );
    },
  );
}

/**
 * Requests the missing translation for one element, one language, one kind.
 * 
 * @ignore
 */
function translate_cell_button(
  proposal,
  org_id,
  effect_dispatch,
  element_id,
  language,
  kind
) {
  return $button.ghost(
    toList([
      $e.on_click(
        (_) => {
          let _block;
          let _pipe = $proposal_effects.translate_element(
            proposal.id,
            element_id,
            org_id,
            language,
            kind,
          );
          _block = effect_dispatch(_pipe);
          let $ = _block;
          
          return undefined;
        },
      ),
    ]),
    toList([$icons.very_tiny($icons.translate())]),
  );
}

function answer_lang_cells(
  proposal,
  org_id,
  effect_dispatch,
  translations,
  element_id,
  target_id,
  version,
  languages,
  is_latest
) {
  return $list.map(
    languages,
    (lang) => {
      let _pipe = translations;
      let _pipe$1 = $list.find(
        _pipe,
        (t) => {
          return (((t.target_id === target_id) && (t.metadata.target_type instanceof $translate.Answer)) && (t.version === version)) && (isEqual(
            t.language,
            lang
          ));
        },
      );
      let _pipe$2 = $result.map(
        _pipe$1,
        (t) => {
          return $versioning_common.text(
            (() => {
              let _pipe$2 = t.content;
              return $html_parser.clean_html_string(_pipe$2);
            })(),
          );
        },
      );
      let _pipe$3 = $result.lazy_unwrap(
        _pipe$2,
        () => {
          if (is_latest) {
            return translate_cell_button(
              proposal,
              org_id,
              effect_dispatch,
              element_id,
              lang,
              new $translate.Answer(),
            );
          } else {
            return $versioning_common.text("—");
          }
        },
      );
      return $table.cell(_pipe$3);
    },
  );
}

function version_badge(ans) {
  return $l.column(
    toList([$l.gap(6), $l.align("center")]),
    toList([]),
    toList([
      $versioning_common.text(
        (() => {
          let _pipe = ans.version;
          return $int.to_string(_pipe);
        })(),
      ),
      (() => {
        let _block;
        let $ = ans.metadata.writing_method;
        if ($ instanceof $answer.HumanWritting) {
          _block = $icons.add_user();
        } else if ($ instanceof $answer.AiFirstGeneration) {
          _block = $icons.sparkles();
        } else if ($ instanceof $answer.AiImprove) {
          _block = $icons.gear();
        } else if ($ instanceof $answer.Rollback) {
          _block = $icons.refresh_line();
        } else {
          _block = $icons.external_link();
        }
        let _pipe = _block;
        return $icons.small(_pipe);
      })(),
    ]),
  );
}

function format_datetime(ts) {
  let _block;
  let _pipe = ts;
  let _pipe$1 = $timestamp_.to_datetime_local(_pipe);
  _block = $string.split(_pipe$1, "T");
  let parts = _block;
  if (parts instanceof $Empty) {
    return $versioning_common.text(
      (() => {
        let _pipe$2 = ts;
        return $timestamp_.to_datetime_local(_pipe$2);
      })(),
    );
  } else {
    let $ = parts.tail;
    if ($ instanceof $Empty) {
      return $versioning_common.text(
        (() => {
          let _pipe$2 = ts;
          return $timestamp_.to_datetime_local(_pipe$2);
        })(),
      );
    } else {
      let $1 = $.tail;
      if ($1 instanceof $Empty) {
        let date = parts.head;
        let time = $.head;
        return $l.column(
          toList([]),
          toList([]),
          toList([
            $versioning_common.text($string.replace(date, "-", "/")),
            $versioning_common.text(time),
          ]),
        );
      } else {
        return $versioning_common.text(
          (() => {
            let _pipe$2 = ts;
            return $timestamp_.to_datetime_local(_pipe$2);
          })(),
        );
      }
    }
  }
}

function question_lang_cells(
  proposal,
  org_id,
  effect_dispatch,
  translations,
  question_id,
  languages
) {
  return $list.map(
    languages,
    (lang) => {
      let _pipe = translations;
      let _pipe$1 = $list.find(
        _pipe,
        (t) => {
          return ((t.target_id === question_id) && (t.metadata.target_type instanceof $translate.Question)) && (isEqual(
            t.language,
            lang
          ));
        },
      );
      let _pipe$2 = $result.map(
        _pipe$1,
        (t) => {
          return $versioning_common.text(
            (() => {
              let _pipe$2 = t.content;
              return $html_parser.clean_html_string(_pipe$2);
            })(),
          );
        },
      );
      let _pipe$3 = $result.lazy_unwrap(
        _pipe$2,
        () => {
          return translate_cell_button(
            proposal,
            org_id,
            effect_dispatch,
            question_id,
            lang,
            new $translate.Question(),
          );
        },
      );
      return $table.cell(_pipe$3);
    },
  );
}

function question_rows(
  proposal,
  org_id,
  effect_dispatch,
  question,
  answers,
  translations,
  languages,
  has_numbering
) {
  let numbering = "";
  let question_cell = $versioning_common.text(
    (() => {
      let _pipe = question.content;
      return $html_parser.clean_html_string(_pipe);
    })(),
  );
  let _block;
  if (has_numbering) {
    _block = toList([$table.cell($versioning_common.text(numbering))]);
  } else {
    _block = toList([]);
  }
  let numbering_cell = _block;
  let question_row = $table.row(
    $list.flatten(
      toList([
        toList([$table.cell(format_datetime(question.created_at))]),
        numbering_cell,
        toList([
          $table.cell(question_cell),
          $table.cell($versioning_common.text("")),
          $table.cell($versioning_common.text("-")),
        ]),
        question_lang_cells(
          proposal,
          org_id,
          effect_dispatch,
          translations,
          question.id,
          languages,
        ),
      ]),
    ),
  );
  let _block$1;
  let _pipe = answers;
  let _pipe$1 = $list.filter(
    _pipe,
    (a) => {
      return (a.element_id === question.id) && (a.kind instanceof $answer.Long);
    },
  );
  let _pipe$2 = $list.group(_pipe$1, (a) => { return a.answer_id; });
  let _pipe$3 = $dict.to_list(_pipe$2);
  let _pipe$4 = $list.sort(
    _pipe$3,
    (g1, g2) => { return $string.compare(g1[0], g2[0]); },
  );
  _block$1 = $list.flat_map(
    _pipe$4,
    (group) => {
      let versions = group[1];
      let _pipe$5 = versions;
      let _pipe$6 = $list.sort(
        _pipe$5,
        (a1, a2) => { return $int.compare(a2.version, a1.version); },
      );
      return $list.index_map(
        _pipe$6,
        (ans, index) => {
          let _block$2;
          if (has_numbering) {
            _block$2 = toList([$table.cell($versioning_common.text(""))]);
          } else {
            _block$2 = toList([]);
          }
          let empty_numbering_cell = _block$2;
          return $table.row(
            $list.flatten(
              toList([
                toList([$table.cell(format_datetime(ans.created_at))]),
                empty_numbering_cell,
                toList([
                  $table.cell($versioning_common.text("")),
                  $table.cell(version_badge(ans)),
                  $table.cell(
                    $versioning_common.text(
                      (() => {
                        let _pipe$7 = ans.value;
                        return $html_parser.clean_html_string(_pipe$7);
                      })(),
                    ),
                  ),
                ]),
                answer_lang_cells(
                  proposal,
                  org_id,
                  effect_dispatch,
                  translations,
                  question.id,
                  ans.answer_id,
                  ans.version,
                  languages,
                  index === 0,
                ),
              ]),
            ),
          );
        },
      );
    },
  );
  let answer_rows = _block$1;
  return listPrepend(question_row, answer_rows);
}

function element_rows(
  proposal,
  org_id,
  effect_dispatch,
  element,
  answers,
  translations,
  languages,
  has_numbering
) {
  if (element instanceof $proposal_element.Question) {
    let question = element.question;
    return question_rows(
      proposal,
      org_id,
      effect_dispatch,
      question,
      answers,
      translations,
      languages,
      has_numbering,
    );
  } else if (element instanceof $proposal_element.Table) {
    return toList([]);
  } else if (element instanceof $proposal_element.Block) {
    return toList([]);
  } else {
    return toList([]);
  }
}

function elements_table(
  proposal,
  org_id,
  effect_dispatch,
  elements,
  answers,
  translations
) {
  let languages = proposal_languages(proposal);
  let has_numbering = false;
  let lang_headers = $list.map(
    languages,
    (lang) => {
      let _pipe = $table.header(
        ($language.to_emoji(lang) + " ") + $string.capitalise(
          $language.to_string(lang),
        ),
      );
      return $table.fit(_pipe);
    },
  );
  let _block;
  _block = toList([]);
  let numbering_header = _block;
  let headers = $list.flatten(
    toList([
      toList([
        (() => {
          let _pipe = $table.header("Created at");
          return $table.clamp(_pipe, "160px", 200);
        })(),
      ]),
      numbering_header,
      toList([
        (() => {
          let _pipe = $table.header("Question");
          return $table.fit(_pipe);
        })(),
        (() => {
          let _pipe = $table.header("v");
          return $table.clamp(_pipe, "60px", 80);
        })(),
        (() => {
          let _pipe = $table.header("Answer V2");
          return $table.fit(_pipe);
        })(),
      ]),
      lang_headers,
    ]),
  );
  return $table.table(
    toList([]),
    toList([
      $table.headers(headers),
      $table.body(
        $list.flat_map(
          elements,
          (element) => {
            return element_rows(
              proposal,
              org_id,
              effect_dispatch,
              element,
              answers,
              translations,
              languages,
              has_numbering,
            );
          },
        ),
      ),
    ]),
  );
}

export function view() {
  return $redraw.compose(
    title_header(),
    (header) => {
      return $redraw.component_(
        "ProposalTranslations",
        (proposal_id) => {
          let store = $store.use_state();
          let dispatch = $store.use_effect_dispatch();
          let _block;
          let _pipe = store.proposal_elements;
          let _pipe$1 = $dict.get(_pipe, proposal_id);
          _block = $result.is_ok(_pipe$1);
          let has_elements = _block;
          let _block$1;
          let _pipe$2 = store.answers;
          let _pipe$3 = $dict.get(_pipe$2, proposal_id);
          _block$1 = $result.is_ok(_pipe$3);
          let has_answers = _block$1;
          let _block$2;
          let _pipe$4 = store.translations;
          let _pipe$5 = $dict.get(_pipe$4, proposal_id);
          _block$2 = $result.is_ok(_pipe$5);
          let has_translations = _block$2;
          $redraw.use_effect(
            () => {
              let _pipe$6 = toList([
                (() => {
                  if (has_elements) {
                    return $effect.none();
                  } else {
                    return $proposal_effects.fetch_proposal_elements(
                      proposal_id,
                    );
                  }
                })(),
                (() => {
                  if (has_answers) {
                    return $effect.none();
                  } else {
                    return $answer_effects.fetch_answers(proposal_id);
                  }
                })(),
                (() => {
                  if (has_translations) {
                    return $effect.none();
                  } else {
                    return $proposal_effects.fetch_translations(proposal_id);
                  }
                })(),
              ]);
              let _pipe$7 = $effect.batch(_pipe$6);
              dispatch(_pipe$7);
              return undefined;
            },
            [has_elements, has_answers, has_translations],
          );
          let $ = store.proposals;
          if ($ instanceof $remote.NotLoaded) {
            return $l.column(
              toList([$l.gap(48)]),
              toList([]),
              listPrepend(
                $skeleton.custom(px(800), px(120)),
                $list.repeat($skeleton.custom(px(1200), px(80)), 10),
              ),
            );
          } else if ($ instanceof $remote.Loading) {
            return $l.column(
              toList([$l.gap(48)]),
              toList([]),
              listPrepend(
                $skeleton.custom(px(800), px(120)),
                $list.repeat($skeleton.custom(px(1200), px(80)), 10),
              ),
            );
          } else if ($ instanceof $remote.Errored) {
            return $l.column(
              toList([$l.gap(48)]),
              toList([]),
              listPrepend(
                $skeleton.custom(px(800), px(120)),
                $list.repeat($skeleton.custom(px(1200), px(80)), 10),
              ),
            );
          } else {
            let pagination = $[0];
            let _block$3;
            let $1 = (() => {
              let _pipe$6 = pagination.elements;
              return $list.find(
                _pipe$6,
                (p) => { return p.id === proposal_id; },
              );
            })();
            let $2 = (() => {
              let _pipe$6 = store.proposal_elements;
              return $dict.get(_pipe$6, proposal_id);
            })();
            let $3 = (() => {
              let _pipe$6 = store.answers;
              return $dict.get(_pipe$6, proposal_id);
            })();
            let $4 = (() => {
              let _pipe$6 = store.translations;
              return $dict.get(_pipe$6, proposal_id);
            })();
            if ($1 instanceof Ok) {
              if ($2 instanceof Ok && $3 instanceof Ok && $4 instanceof Ok) {
                let proposal = $1[0];
                let elements = $2[0];
                let answers = $3[0];
                let translations = $4[0];
                _block$3 = toList([
                  header(proposal),
                  elements_table(
                    proposal,
                    $option.unwrap(store.organization, ""),
                    dispatch,
                    elements,
                    answers,
                    translations,
                  ),
                ]);
              } else {
                let proposal = $1[0];
                _block$3 = listPrepend(
                  header(proposal),
                  $list.repeat($skeleton.custom(px(1200), px(80)), 10),
                );
              }
            } else {
              _block$3 = listPrepend(
                $skeleton.custom(px(800), px(120)),
                $list.repeat($skeleton.custom(px(1200), px(80)), 10),
              );
            }
            let _pipe$6 = _block$3;
            return ((_capture) => {
              return $l.column(
                toList([$l.gap(48), $l.styles(toList([$css.z_index(8000)]))]),
                toList([]),
                _capture,
              );
            })(_pipe$6);
          }
        },
      );
    },
  );
}
